export const TIMEOUTS = {
    quick: 225,
    medium: 275,
    slow: 300,
} as const;
export type Timeout = keyof typeof TIMEOUTS;
